export default __webpack_public_path__ + "static/4-Yard-Dumpster-764ed23965ab6017b7772ce7cb933066.jpg";